<template lang="pug">
  .lesson-block.main-block
    .lesson-block__content
      p.lesson-block__title.main-block__title
        | {{contentLocal.title}}

      .lesson-block__markdown.form-item__markdown(
        v-if="contentLocal.description"
        v-html="makeHtml(contentLocal.description)"
      )

      .lesson-block-franch-team-rate__header.lesson-block-franch-team__header
        .lesson-block-franch-team-rate__member
          .lesson-block-franch-team-rate__member-img
            Avatar(
              :img="user.avatar"
              circle
              size="s"
            )
          .lesson-block-franch-team-rate__member-info
            .lesson-block-franch-team-rate__member-name
              | {{user.name}} {{user.lastname}}
            .lesson-block-franch-team-rate__member-location
              | {{user.city}}
        .lesson-block-franch-team-rate__stars.-header-
          .lesson-block-franch-team-rate__stars-title
            | Общая оценка:
          .lesson-block-franch-team-rate__stars-points
            | {{contentLocal.userRating ? contentLocal.userRating : 0}}

      .lesson-block-franch-team-marks(v-if="contentLocal.answers.length")
        .lesson-block-franch-team-marks__header(
          @click="marksIsOpen = !marksIsOpen"
          :class="{'-active-': marksIsOpen}"
        )
          .lesson-block-franch-team-marks__title
            | Мои оценки:
          .lesson-block-franch-team-marks__icon
            Icon(icon="arrow-left" :class="{'-active-': marksIsOpen}")

        SlideUpDown.lesson-block-franch-team-marks-list(
          :duration="200"
          :active="marksIsOpen"
          tag="div"
        )
          .lesson-block-franch-team-marks-item(v-for="(mark, idx) in contentLocal.answers" :key="idx")
            .lesson-block-franch-team-marks-item__stars
              svg.lesson-block-franch-team-marks-item__star(
                v-for="(star, sIdx) in markStars(mark)" :key="sIdx"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 13 12" fill="none"
              )
                path(
                  v-if="star.type === 'full'"
                  d="M6.25033 9.07449L9.85533 11.2503L8.89866 7.14949L12.0837 4.39033L7.88949 4.03449L6.25033 0.166992L4.61116 4.03449L0.416992 4.39033L3.60199 7.14949L2.64533 11.2503L6.25033 9.07449Z" fill="#FECB52"
                )
                path(
                  v-else-if="star.type === 'empty'"
                  d="M5.83333 8.9075L9.43833 11.0833L8.48167 6.9825L11.6667 4.22333L7.4725 3.8675L5.83333 0L4.19417 3.8675L0 4.22333L3.185 6.9825L2.22833 11.0833L5.83333 8.9075Z" fill="#DFE0EB"
                )

            .lesson-block-franch-team-marks-item__comment
              | {{mark.comment}}

      .lesson-block-franch-team
        p.lesson-block__title.main-block__title
          | Команда:
        TeamRate(
          v-for="answer in contentLocal.teamAndAnswers" :key="answer.userId"
          :propAnswer="answer"
          :block="block"
        )
    slot
</template>

<script>
import _ from 'lodash';
import markdownToHtml from '@/functions/converterMarkdownToHtml';
import TeamRate from './TeamRate';
import { mapState } from 'vuex';
import SlideUpDown from 'vue-slide-up-down';

export default {
  components: { TeamRate, SlideUpDown },
  props: {
    content: {},
    block: {}
  },
  data() {
    return {
      contentLocal: {
        answers: []
      },
      isLoading: false,
      marksIsOpen: false
    };
  },
  computed: {
    ...mapState('auth', {
      user: s => s.data.user
    })
  },
  watch: {
    content() {
      this.setData();
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.contentLocal = _.cloneDeep(this.content);
    },
    makeHtml(value) {
      return markdownToHtml.makeHtml(value);
    },
    markStars(mark) {
      const stars = [];
      for (let i = 0; i < mark.stars; i++) {
        stars.push({
          type: 'full'
        });
      }

      while (stars.length < 10) {
        stars.push({
          type: 'empty'
        });
      }
      return stars;
    }
  }
};
</script>
